import createCache, { type EmotionCache } from '@emotion/cache';

/**
 * MUI styles through Emotion, which injects `<style>` elements at runtime. The Content-Security-
 * Policy allows no inline style (SDD §12.5), so each style element carries the per-response nonce
 * that Nginx writes into `<meta name="csp-nonce">` and into `style-src 'nonce-…'`. Without it the
 * browser drops every MUI rule in the deployed build.
 *
 * Outside Nginx (Vite dev server, tests) there is no CSP and the placeholder is harmless.
 */
export function createEmotionCache(doc: Document = document): EmotionCache {
  const nonce = doc.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') ?? '';
  return createCache(nonce === '' ? { key: 'css' } : { key: 'css', nonce });
}

let shared: EmotionCache | undefined;

/**
 * The page's one style cache. A new cache knows none of the styles already in the page, so it
 * inserts them all again and the old `<style>` elements stay behind. One cache per page load keeps
 * each rule inserted once, however often the app is mounted (each web test mounts it afresh).
 */
export function appEmotionCache(): EmotionCache {
  shared ??= createEmotionCache();
  return shared;
}
